import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import { Form, Modal } from 'react-bootstrap';
import { cancelStudentInvoiceById, updateStudentInvoicePayment } from '@app/services/student';
import CurrencyFormat from 'react-currency-format';
import { confirmAlert } from 'react-confirm-alert';

const PayInvoiceAmountModal = (props) => {

    const [isLoading, setLoading] = useState(false);

    const updateInvoicePayment = async (payload) => {
        try {
            setLoading(true);
            const resp = await updateStudentInvoicePayment(payload);
            if(resp.success === true){
                setLoading(false);
                toast.success(resp?.message);
                props.handleClose();
                props.callBackGetAllStudentInvoices();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error');
        }
    };

    const cancelInvoice = async () => {
        try {
            setLoading(true);
            const resp = await cancelStudentInvoiceById(props?.payload?.student_invoice_id);
            if(resp.success === true){
                setLoading(false);
                toast.success(resp?.message);
                props.handleClose();
                props.callBackGetAllStudentInvoices();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error');
        }
    };

     const cancelInvoiceConfirm = (e) => {
        props.handleClose()
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to cancel this invoice?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => cancelInvoice()
                },
                {
                    label: 'No',
                    onClick: () => {}
                }
            ]
        });
        e.preventDefault();
    }

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: {
            student_invoice_id: props?.payload?.student_invoice_id ?? '',
            amount_paid: props?.payload?.amount_outstanding,
            comment: '',
        },
        validationSchema: Yup.object({
            amount_paid: Yup.number().required('Please enter amount')
                    .min(0.01, "Amount must be greater than or equal to 0.01")
                    .max(props?.payload?.amount_outstanding, "Amount must be less than or equal to " + props?.payload?.amount_outstanding),
            comment: Yup.string().max(150, 'Comment must be at most 150 characters'),
        }),
        onSubmit: (values) => {
            updateInvoicePayment(values);
        },
        enableReinitialize: true,
    });

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose} size='lg'>
            <Modal.Header>
                <Modal.Title>Update Invoice Payment </Modal.Title>
                {/* <Button type="button" isLoading={isLoading} className="btn btn-danger btn-sm mr-2"  onClick={ (e) => { cancelInvoiceConfirm(e) } } data-toggle="tooltip" title="Cancel Invoice">Cancel Invoice</Button> */}
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <dt>Invoice Number </dt>
                                <dd>#{ props?.payload?.invoice_number } </dd>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <dt>Student Name</dt>
                                <dd>{ props?.payload?.student_name ?? '---' }</dd>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <dt>Franchise</dt>
                                <dd>{ props?.payload?.franchise_name ?? '---' }</dd>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <dt>Total Payable Amount</dt>
                                <dd><CurrencyFormat value={ props?.payload?.invoice_amount } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={props?.payload?.currency + ' '} /></dd>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <dt>Outstanding Amount</dt>
                                <dd><CurrencyFormat value={ props?.payload?.amount_outstanding } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={props?.payload?.currency + ' '} /></dd>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <dt>Amount Paid</dt>
                                <dd><CurrencyFormat value={ props?.payload?.amount_paid } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={props?.payload?.currency + ' '} /></dd>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className='row ml-4'>
                        <div className="col-sm-8">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Amount Paid<span className="required">*</span></label>
                                <div className='input-group'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">{ props?.payload?.currency }</span>
                                    </div>
                                    <Form.Control 
                                        className='col-sm-9'
                                        type="number" 
                                        name="amount_paid" 
                                        id="amount_paid" 
                                        placeholder="Enter amount" 
                                        value={values.amount_paid}
                                        onChange={handleChange}
                                        onWheel={ (e) => e.currentTarget.blur() }
                                    />
                                </div>
                                {(touched.amount_paid && errors.amount_paid) && (
                                    <div className="text-danger">
                                        {errors.amount_paid}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-8">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Comment</label>
                                <textarea 
                                    className="form-control" 
                                    id="exampleInputEmail1" 
                                    placeholder="Enter comment" 
                                    name="comment" 
                                    onChange={handleChange} 
                                    value={values.comment}
                                    rows={3}
                                ></textarea>
                                {(touched.comment && errors.comment) && (
                                    <div className="text-danger">
                                        {errors.comment}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" isLoading={isLoading} className="btn btn-primary mr-2">Update </Button>
                    <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default PayInvoiceAmountModal;